module.exports = {"610722001":"博望街道","610722002":"莲花街道","610722101":"龙头镇","610722102":"沙河营镇","610722103":"文川镇","610722104":"柳林镇","610722105":"老庄镇","610722107":"桔园镇","610722108":"原公镇","610722109":"上元观镇","610722110":"天明镇","610722111":"二里镇","610722112":"五堵镇","610722114":"双溪镇","610722116":"小河镇","610722119":"董家营镇","610722120":"三合镇","610722400":"陕西飞机制造公司"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610722.json
// module id = 2988
// module chunks = 0